import React from 'react'
import { ListGroup, ListGroupItem, Badge, Spinner, Button } from 'reactstrap'
import moment from 'moment'

const ConversationList = ({ conversations, activeConversation, onSelectConversation, onJoinConversation, loading, user }) => {
  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner color="primary" />
        <p className="mt-2">Loading conversations...</p>
      </div>
    )
  }

  if (conversations.length === 0) {
    return (
      <div className="text-center py-4 text-muted">
        <i className="mdi mdi-chat-outline" style={{ fontSize: '48px' }}></i>
        <p>No active conversations</p>
      </div>
    )
  }

  const getLastMessage = (conversation) => {
    if (conversation.messages && conversation.messages.length > 0) {
      const lastMsg = conversation.messages[conversation.messages.length - 1]
      return lastMsg.message
    }
    return 'No messages yet'
  }

  const getStatusColor = (status) => {
    switch (status) {
      case 'open':
        return 'warning'
      case 'pending':
        return 'info'
      case 'assigned':
        return 'success'
      case 'closed':
        return 'secondary'
      default:
        return 'primary'
    }
  }

  const isUnassigned = (conversation) => {
    return (conversation.status === 'pending' || conversation.status === 'open') && !conversation.assigned_agent_id
  }

  return (
    <div className="conversation-list">
      {conversations.map((conversation) => (
        <div
          key={conversation.id}
          className={`conversation-item ${activeConversation?.id === conversation.id ? 'active' : ''} ${conversation.isNew ? 'blinking' : ''}`}
          onClick={() => onSelectConversation(conversation)}
        >
          <div className="d-flex">
            <div className="avatar-placeholder">
              {conversation.customer_name ? conversation.customer_name.charAt(0).toUpperCase() : 'A'}
            </div>
            <div className="content">
              <div className="top-row">
                <h6 className="customer-name">
                  {conversation.customer_name || 'Anonymous'}
                </h6>
                <span className="time">
                  {moment(conversation.updated_at).format('h:mm A')}
                </span>
              </div>

              <p className="last-message">
                {getLastMessage(conversation)}
              </p>

              <div className="badges">
                {isUnassigned(conversation) && (
                  <Badge color="warning" pill style={{ fontSize: '10px' }}>
                    Unassigned
                  </Badge>
                )}

                {conversation.unread_count > 0 && (
                  <Badge color="danger" pill>
                    {conversation.unread_count}
                  </Badge>
                )}

                <Badge color={getStatusColor(conversation.status)} pill style={{ fontSize: '10px', opacity: 0.8 }}>
                  {conversation.transferredTo ? (
                    `Transferred to ${conversation.transferredTo.first_name || 'Agent'}`
                  ) : user?.id === conversation?.assigned_agent_id ? (
                    'Assigned to you'
                  ) : (
                    conversation.assignedAgent ? `Assigned to ${conversation.assignedAgent.first_name}` : conversation.status
                  )}
                </Badge>
              </div>

              {isUnassigned(conversation) && onJoinConversation && (
                <div className="mt-2">
                  <Button
                    color="primary"
                    size="sm"
                    className="w-100 py-1"
                    style={{ fontSize: '0.8rem' }}
                    onClick={(e) => {
                      e.stopPropagation()
                      onJoinConversation(conversation.id)
                    }}
                  >
                    Join Chat
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      ))
      }
    </div >
  )
}

export default ConversationList
